import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../contexts/RestaurantContext";
import "./MobileBottomNav.css";

const NAV_ITEMS = [
    { id: "home", label: "Home", path: "/home" },
    { id: "combo", label: "Combo", path: "/combos" },
    { id: "menu", label: "Menu", path: "/menu" },
];

const MobileBottomNav = ({ activePage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { restaurantSlug } = useRestaurant();
    const normalizedActivePageProp = String(activePage || "").toLowerCase();
    const pathname = String(location?.pathname || "").toLowerCase();

    const normalizedActivePage = pathname.includes("/combos") || pathname.includes("/deals")
        ? "combo"
        : pathname.includes("/menu")
            ? "menu"
            : pathname.includes("/home")
                ? "home"
                : normalizedActivePageProp;

    const isActiveItem = (itemId) => {
        if (itemId === "combo") {
            return normalizedActivePage === "combo" || normalizedActivePage === "combos";
        }
        if (itemId === "menu") {
            return normalizedActivePage === "menu";
        }
        if (itemId === "home") {
            return normalizedActivePage === "home";
        }
        return normalizedActivePage === itemId;
    };

    return (
        <div className="mobile-bottom-nav">
            {NAV_ITEMS.map((item) => (
                <button
                    type="button"
                    key={item.id}
                    className={isActiveItem(item.id) ? "mobile-nav-item-active" : "mobile-nav-item"}
                    onClick={() => restaurantSlug && navigate(`/${restaurantSlug}${item.path}`)}
                >
                    <div className={isActiveItem(item.id) ? "mobile-nav-text-active" : "mobile-nav-text"}>
                        {item.label}
                    </div>
                </button>
            ))}
        </div>
    );
};

export default MobileBottomNav;
